import app from 'app';
import { workPool } from '@wochitnpm/helpers';

/**
 * @namespace workPool.job.waitTillDefined
 * Wait till some deep field in baseObj becomes defined (and not null)
 *
 * @example
 * wait till window.FS.getCurrentSessionURL becomes defined
 * workPool.job.waitTillDefined.start({
 *    baseObj: window,
 *    field: 'FS.getCurrentSessionURL',
 *    timeout: app.TIME.minute(2) + _.random(-10e3, +10e3),
 * });
 */
export default workPool.define(
  'waitTillDefined',
  {
    getContext() {
      return {
        baseObj: this.options.baseObj,
        field: this.options.field,
      };
    },

    run() {
      this.options = _.merge(
        {
          timeout: 60e3 + _.random(-10e3, +10e3),
          interval: 1e3 + _.random(-100, +100),
        },
        this.options
      );

      if (this.options.baseObj[this.options.field]) {
        this.onDone(this.options.baseObj[this.options.field]);
        return;
      }

      const startTime = Date.now();
      const timer = new app.namespace.Util.Timer(() => {
        const isTimeout = Date.now() - startTime > this.options.timeout;
        const value = this._probeField();

        if (_.isDefined(value)) {
          this.onDone(value);
        } else if (isTimeout) {
          this.finish();
        } else {
          timer.start();
        }
      }, this.options.interval);
      timer.start();
    },

    _probeField() {
      let tmp = this.options.baseObj;
      const fields = this.options.field.split('.');

      for (const field of fields) {
        tmp = tmp[field];
        if (!_.isDefined(tmp)) {
          break;
        }
      }

      return tmp;
    },

    onDone(value) {
      this.$emit({ value });
      this.finish();
    },
  },
  {
    start({ baseObj, field, timeout, interval }) {
      workPool.add(new this({ baseObj, field, timeout, interval }));
    },
  }
);
